import React from 'react'
import { Route } from 'react-router'
import Dashboard from './dashboard-1/Dashboard'
import HomeMenu from './Menu'

export default <Route path="/home/dashboard-1" component={Dashboard} />
export { HomeMenu }
